import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";

import { ListBlock } from "@/components/layout/ListBlock";

type InfoListStoryblok = {
  title?: string;
  text?: string;
  items?: any[];
  _uid: string;
  component: "info_list";
  [k: string]: any;
};

type InfoListProps = {
  blok: InfoListStoryblok;
};

const InfoList = ({ blok }: InfoListProps) => {
  return (
    <div {...storyblokEditable(blok)}>
      <ListBlock variant="divider" title={blok.title}>
        {blok.text && (
          <p className="text-copy whitespace-pre-line">{blok.text}</p>
        )}
        {blok.items?.map((nestedBlok: any) => (
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))}
      </ListBlock>
    </div>
  );
};

export default InfoList;
